import { FC, ReactNode } from 'react';
import AlertErrorIcon from 'src/assets/icons/AlertErrorIcon';

const variantIconsMapping = {
  error: <AlertErrorIcon />,
};

interface AlertProps {
  variant: 'error';
  children: ReactNode;
}

const Alert: FC<AlertProps> = ({ variant, children }) => (
  <div
    className={`px-6 py-2 flex items-center justify-start gap-2 bg-${variant} bg-opacity-30 rounded`}
  >
    <div>{variantIconsMapping[variant]}</div>
    {typeof children === 'string' ? <p className="grow">{children}</p> : children}
  </div>
);

export default Alert;
